import React from 'react';
import { ArrowDownRight, ArrowUpRight, GitCompare, Minus } from 'lucide-react';
import { inr, pct } from './format';

const ROWS = [
  ['total_pos', 'Purchase Orders', 'count', true],
  ['total_grns', 'GRNs', 'count', true],
  ['total_po_value', 'PO Value', 'money', true],
  ['total_grn_received_value', 'GRN Value', 'money', true],
  ['pending_po_value', 'Pending PO Value', 'money', false],
  ['total_ppv', 'Purchase Price Variance', 'money', false],
  ['open_exceptions', 'Open Exceptions', 'count', false],
  ['inward_margin_pct', 'Inward Margin %', 'pct', true],
  ['outward_margin_pct', 'Outward Margin %', 'pct', true],
  ['current_margin_pct', 'Current Margin %', 'pct', true],
];

const fmt = (v, type) => (type === 'money' ? inr(v) : type === 'pct' ? pct(v) : v === null || v === undefined ? '—' : Number(v).toLocaleString('en-IN'));

const Delta = ({ cur, prev, type, upGood }) => {
  if (cur === null || cur === undefined || prev === null || prev === undefined) return <span className="text-slate-400">—</span>;
  const diff = cur - prev;
  if (Math.abs(diff) < 0.005) return <span className="inline-flex items-center gap-1 text-slate-500"><Minus size={12} />No change</span>;
  const good = upGood ? diff > 0 : diff < 0;
  const Icon = diff > 0 ? ArrowUpRight : ArrowDownRight;
  const rel = type === 'pct' ? `${diff > 0 ? '+' : ''}${diff.toFixed(2)} pp` : prev ? `${diff > 0 ? '+' : ''}${(diff / Math.abs(prev) * 100).toFixed(1)}%` : 'new';
  return <span className={`inline-flex items-center gap-1 font-semibold ${good ? 'text-emerald-600' : 'text-rose-600'}`}><Icon size={13} />{rel}</span>;
};

export const PeriodComparison = ({ comparison, labels }) => {
  if (!comparison || !labels) return null;
  const c = comparison.current.kpis; const p = comparison.previous.kpis;
  return (
    <div className="rounded-xl border border-slate-200 bg-white overflow-hidden" data-testid="period-comparison">
      <div className="px-4 py-3 border-b border-slate-100 flex flex-wrap items-center gap-2">
        <GitCompare size={16} className="text-indigo-600" />
        <span className="text-sm font-semibold text-slate-800">Period Comparison</span>
        <span className="text-[11px] text-slate-500" data-testid="period-comparison-labels">
          {labels.curLabel} ({comparison.current.from} → {comparison.current.to}) vs {labels.prevLabel} ({comparison.previous.from} → {comparison.previous.to}) · by PO date
        </span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead className="bg-slate-50 text-slate-600">
            <tr>
              <th className="px-4 py-2 text-left font-semibold">Metric</th>
              <th className="px-4 py-2 text-right font-semibold">{labels.curLabel}</th>
              <th className="px-4 py-2 text-right font-semibold">{labels.prevLabel}</th>
              <th className="px-4 py-2 text-right font-semibold">Change</th>
            </tr>
          </thead>
          <tbody>
            {ROWS.map(([k, label, type, upGood]) => (
              <tr key={k} className="border-t border-slate-100" data-testid={`compare-row-${k}`}>
                <td className="px-4 py-2 text-slate-700">{label}</td>
                <td className="px-4 py-2 text-right tabular-nums font-semibold text-slate-900">{fmt(c[k], type)}</td>
                <td className="px-4 py-2 text-right tabular-nums text-slate-600">{fmt(p[k], type)}</td>
                <td className="px-4 py-2 text-right tabular-nums"><Delta cur={c[k]} prev={p[k]} type={type} upGood={upGood} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
